
const DATA = [
  { name: 'id', type: 'textinput',options: [], searchField: '',  nullable: false, editable: true, export: true, import: true },
  { name: 'email',  type: 'textinput', nullable: false, editable: false, export: true },
  { name: 'status', type: 'status',options: [{id: 0, name: "Inactive"}, {id: 1, name: "Active"}], nullable: false, editable: true, export: true, import: true },
  { name: 'created', type: 'textinput', nullable: false, editable: true, export: true, import: true },
]
export default DATA;